<template>
  <option-modal
    class="delete-workflow-modal"
    title-modal="Delete experiment"
    :apply-btn="applyBtn"
    @on-close="close"
  >
    <p class="body-1">"{{currentWorkflow.title}}" experiment will be permanently deleted.</p>
  </option-modal>
</template>

<script>
import saveWorkflow from '@/components/workflow/mixins/saveWorkflow';
import callToApiBackend from '@/components/workflow/mixins/callToApiBackend';
import OptionModal from "./option-modal";
import { showGlobalBanner } from '@/services/global-banner.js';

export default {
  name: "OptionModalDelete",
  components: { OptionModal },
  mixins: [ saveWorkflow, callToApiBackend ],
  props: {
    currentWorkflow: { type: Object }
  },
  inject: ['getMyWorkflows'],
  computed: {
    applyBtn() {
      return {
        name: 'Delete',
        icon: 'delete',
        color: '#ffffff',
        disabled: false,
        func: this.apply,
      }
    }
  },
  methods: {
    close() {
      this.$emit('on-close')
    },
    apply() {
      this.close();
      this.updateSingleWorkflowAPI('delete', this.currentWorkflow.id)
        .then(() => {
          this.$snackbar({title: '1 experiment deleted.', btn: null, duration: 6000});
          if(this.getMyWorkflows) this.getMyWorkflows();
        })
        .catch(() => {
          showGlobalBanner(this, {
            title: 'Experiment could not be deleted',
            body: 'Due to technical reasons we were not able to delete this experiment. Please try again.',
            btn: 'dismiss',
          });
        });
    }
  },
}
</script>
